import { createAction, createSlice } from '@reduxjs/toolkit';
import { CoreMsgTypes, NetAssetValueRecord } from '@tassat/fred-definitions';

export interface NetAssetValuesState {
    [key: string]: NetAssetValueRecord;
}

const initialState: NetAssetValuesState = {};

const initialLoadAction = createAction<{ netAssetValues: NetAssetValuesState }>('InitialLoad');
const netAssetValueRecordAction = createAction<NetAssetValueRecord>(CoreMsgTypes.NetAssetValueRecord);

const netAssetValuesSlice = createSlice({
    name: 'netAssetValues',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(initialLoadAction, (_state, action) => {
                return action.payload.netAssetValues;
            })
            .addCase(netAssetValueRecordAction, (state, action) => {
                state[action.payload.AssetId] = action.payload;
            });
    }
});

export default netAssetValuesSlice.reducer;